module.exports = __webpack_public_path__ + "static/cv_mosca_nikolas-811debe1a77fdcbb80a942d9052a94a8.pdf";